<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
}
</script>

<template>
  <div
    class="booking-section"
  >
    <div v-if="title || $slots['level-right']" class="level subsection" :class="$slots['level-right'] ? 'is-tab-style' : 'is-small'">
      <h4 v-if="title" class="booking-section__title level-left">{{ title }}</h4>
      <div v-if="$slots['level-right']" class="level-right">
        <slot name="level-right"/>
      </div>
    </div>
    <slot/>

  </div>
</template>
